import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cache = null;
export const fetchSpecialDays = () => {
  if (!cache) {
    cache = axios
      .get(`${API}/hours`)
      .then((r) => r.data.special_days || [])
      .catch(() => []);
  }
  return cache;
};

export const dateISO = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const specialFor = (days, d) =>
  (days || []).find((x) => x.date === dateISO(d)) || null;

export const toMin = (t) => {
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
};

// "2026-10-29" -> "29.10."
export const fmtDateDE = (iso) => {
  const [, mo, da] = iso.split("-");
  return `${da}.${mo}.`;
};
